const ADMIN_DASHBOARD_PATH = '/admin-dashboard';
const DOCTOR_DASHBOARD_PATH = '/doctor-dashboard';
const PATIENT_DASHBOARD_PATH = '/patient-dashboard';

const normalizeRole = (value = '') =>
    String(value)
        .trim()
        .replace(/[\s-]+/g, '_')
        .toUpperCase();

const getRoleCandidates = (role) => {
    if (!role) {
        return [];
    }

    if (typeof role === 'string') {
        return [normalizeRole(role)];
    }

    return [normalizeRole(role.roleType), normalizeRole(role.roleName)].filter(Boolean);
};

const hasRole = (candidates, values) =>
    values.some((value) => candidates.includes(normalizeRole(value)));

export const getDashboardPathByRole = (role) => {
    const roleCandidates = getRoleCandidates(role);

    if (hasRole(roleCandidates, ['DOCTOR', 'MEDICAL_DOCTOR'])) return '/doctor-dashboard';
    if (hasRole(roleCandidates, ['MID_WIFE', 'MIDWIFE'])) return '/midwife-dashboard';
    if (hasRole(roleCandidates, ['CASHIER', 'FRONT_CASHIER', 'CASHIER_FRONT'])) return '/cashier-dashboard';
    if (hasRole(roleCandidates, ['FRONT_DESK', 'FRONTDESK'])) return '/front-desk-dashboard';
    if (hasRole(roleCandidates, ['HOSPITAL_ADMIN', 'HOS_ADMIN', 'HOSP_ADMIN'])) return '/hospital-admin-dashboard';
    if (hasRole(roleCandidates, ['LAB_TECHNOLOGIST', 'LAB_TECHNICIAN', 'LAB_TECH', 'LABORATORY_TECHNICIAN', 'LABORATORY_TECHNOLOGIST'])) return '/lab-technician-dashboard';
    if (hasRole(roleCandidates, ['BRANCH_ADMIN', 'BRANCH_ADMINISTRATOR', 'BRANCHADMIN'])) return '/branch-admin-dashboard';
    if (hasRole(roleCandidates, ['NURSE'])) return '/nurse-dashboard';
    if (hasRole(roleCandidates, ['DISPENSER', 'DRUG_DISPENSER'])) return '/dispenser-dashboard';
    if (hasRole(roleCandidates, ['PHARMACIST'])) return '/pharmacist-dashboard';
    if (hasRole(roleCandidates, ['PATIENT'])) return PATIENT_DASHBOARD_PATH;

    return ADMIN_DASHBOARD_PATH;
};

export { ADMIN_DASHBOARD_PATH, DOCTOR_DASHBOARD_PATH, PATIENT_DASHBOARD_PATH };
